import { useMemo } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import * as THREE from "three";

export function Projector({ targets, labels, centerRef }) {
  const { camera, size } = useThree();
  const [v, c, n] = useMemo(() => [new THREE.Vector3(), new THREE.Vector3(), new THREE.Vector3()], []);
  useFrame(() => {
    const arr = targets.current;
    for (let i = 0; i < arr.length; i++) {
      const o = arr[i];
      const el = labels.current[i];
      if (!o || !el) continue;
      o.getWorldPosition(v);
      let vis = 1;
      if (centerRef?.current) {
        centerRef.current.getWorldPosition(c);
        n.copy(v).sub(c).normalize();
        c.copy(camera.position).sub(v).normalize();
        vis = n.dot(c) > 0.25 ? 1 : 0;
      }
      v.project(camera);
      el.style.transform = `translate3d(${(v.x * 0.5 + 0.5) * size.width}px, ${(-v.y * 0.5 + 0.5) * size.height}px, 0)`;
      el.style.opacity = vis;
    }
  });
  return null;
}
